import { api } from '../../core/network/api';

/** design/gdd/insurance.md REST surface — plain wrappers, same convention as economy-api.ts. */

export interface InsuranceStatus {
  /** How many items one covered run protects. Permanent, Wax-bought. */
  insuranceSlots: number;
  /** design/gdd/insurance.md MAX_INSURANCE_SLOTS, so the hub can draw the slot you do not own yet. */
  maxSlots: number;
  nextExpandCostWax: number | null;
  /**
   * How many covered runs are left. Cover is per-run since 2026-09-03 — a run
   * that finished with something insured spends one.
   */
  charges: number;
  maxCharges: number;
  chargeCostWax: number;
}

export const getInsuranceStatus = (): Promise<InsuranceStatus> => api.get('/insurance');

export const expandInsurance = (): Promise<{ insuranceSlots: number; cost: number }> =>
  api.post('/insurance/expand');

/** Buys cover by the run. Separate from `expandInsurance`, which widens it. */
export const buyInsuranceCharges = (count: number): Promise<{ charges: number; cost: number }> =>
  api.post('/insurance/charges', { count });
